// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
/**
 * 初始化入口
 *
 * 1.2016-12-14  rlair_老客户端提示
 * 2.2017-03-14  rlair_修改初始化逻辑
 * 3.2017-05-11  rlair_修复pad上发送按钮和表情按钮重叠的问题
 * 4.2017-08-11  rlair_将sessionStorage设置项__comeback_from_cas__清除
 * 5.2017-08-15  rlair_增加fetch降级处理以解决ios客户端fetch请求支持不完善的问题
 * 6.2018-06-22  rlair_5.0前端合并编译错误调整
 * 7.2018-07-12  rlair_修复桌面端office预览文件出错点击确定页面刷新/卡死的问题
 * 8.2018-08-22  rlair_移除阻止窗体卸载事件监听，放到office预览组件中实现
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router, Route} from 'react-router-dom';

import PDFJS from 'pdfjs-dist';
import smoothscroll from 'smoothscroll-polyfill';

import {getConfig} from 'mattermost-redux/selectors/entities/general';

smoothscroll.polyfill();

// Import our styles
import 'bootstrap-colorpicker/dist/css/bootstrap-colorpicker.css';
import 'sass/styles.scss';
import 'katex/dist/katex.min.css';

import {browserHistory} from 'utils/browser_history';
import {makeAsyncComponent} from 'components/async_load';
import store from 'stores/redux_store.jsx';

// rlair_5.0前端合并编译错误调整
// import loadRoot from 'bundle-loader?lazy!components/root';
import loadRoot from 'bundle-loader?lazy!components/root/index.js';

//增加依赖
import * as Utils from 'utils/utils.jsx';
import * as UserAgent from 'utils/user_agent.jsx';

// 降级fetch
import demoteFetch from 'utils/customsize_fetch.jsx';

const Root = makeAsyncComponent(loadRoot);

PDFJS.disableWorker = true;

// This is for anything that needs to be done for ALL react components.
// This runs before we start to render anything.
function preRenderSetup(callwhendone) {
    window.onerror = (msg, url, line, column, stack) => {
        var l = {};
        l.level = 'ERROR';
        l.message = 'msg: ' + msg + ' row: ' + line + ' col: ' + column + ' stack: ' + stack + ' url: ' + url;

        const req = new XMLHttpRequest();
        req.open('POST', '/api/v4/logs');
        req.setRequestHeader('Content-Type', 'application/json');
        req.send(JSON.stringify(l));

        const state = store.getState();
        const config = getConfig(state);
        if (config.EnableDeveloper === 'true') {
            window.ErrorStore.storeLastError({type: 'developer', message: 'DEVELOPER MODE: A JavaScript error has occurred.  Please use the JavaScript console to capture and report the error (row: ' + line + ' col: ' + column + ').'});
            window.ErrorStore.emitChange();
        }
    };

    callwhendone();
}

function renderRootComponent() {
    ReactDOM.render((
        <Provider store={store}>
            <Router history={browserHistory}>
                <Route
                    path='/'
                    component={Root}
                />
            </Router>
        </Provider>
    ),
    document.getElementById('root'), () => {
        // 手机客户端splash
        if (sessionStorage.getItem('__comeback_from_cas__') && !window.__temp_redirect__) { // eslint-disable-line no-underscore-dangle
            if (window.mapp) {
                Utils.showSplash();
            } else {
                setTimeout(() => {
                    Utils.showSplash();
                }, 0);
            }
            sessionStorage.removeItem('__comeback_from_cas__');
        }

        // 将sessionStorage设置项__comeback_from_cas__清除
        sessionStorage.removeItem('__comeback_from_cas__');
    });
}

/**
 * Adds a function to be invoked onload appended to any existing onload
 * event handlers.
 *
 * @param   {function} fn onload event handler
 *
 */
function appendOnLoadEvent(fn) {
    if (window.attachEvent) {
        window.attachEvent('onload', fn);
    } else if (window.onload) {
        const curronload = window.onload;
        window.onload = (evt) => {
            curronload(evt);
            fn(evt);
        };
    } else {
        window.onload = fn;
    }
}

appendOnLoadEvent(() => {
    // ios客户端，将fetch降级为xhr
    if (UserAgent.isIosApp()) {
        demoteFetch();
    }

    // Do the pre-render setup and call renderRootComponent when done
    preRenderSetup(renderRootComponent);
});

